<template>
	<div class="text-left">
		<cepBankForm v-if="$route.params.withdraw == 'pay'" />
		<withdraw v-else />
	</div>
</template>

<script>
    import withdraw from '@/components/user/transactions/withdraw'
	import cepBankForm from '@/components/payments/form/cepbank'
    export default {
        name: "cepbank",
	    components: {cepBankForm, withdraw}
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/payments/gateways/cepbank.vue